import { render, staticRenderFns } from "./PosReportProducts.vue?vue&type=template&id=0d9f40a8&"
import script from "./PosReportProducts.vue?vue&type=script&lang=js&"
export * from "./PosReportProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports